/**
 * Footer used only on /preview. Live Footer.tsx is not edited.
 * Home links go to `/`, never to this preview URL.
 */

import { Link } from 'react-router-dom';
import { BAKERY_LOCAL } from '../../utils/bakeryLocal';

export default function PreviewFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 text-white">
      <div className="container-custom grid gap-8 py-12 md:grid-cols-3">
        <div>
          <p className="font-display text-2xl font-bold">Nanny B&apos;s Bakery</p>
          <p className="mt-3 max-w-sm text-sm text-gray-400">
            Custom cakes and fresh treats in Barrie. Pickup at Commerce Park.
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-gray-300">Visit</p>
          <p className="mt-3 text-sm text-gray-400">{BAKERY_LOCAL.addressFull}</p>
          <p className="mt-2 text-sm text-gray-400">{BAKERY_LOCAL.hoursShort}</p>
          <a className="mt-2 inline-block text-sm text-primary-300 hover:text-white" href={`tel:${BAKERY_LOCAL.telephone.replace(/\D/g, '')}`}>
            {BAKERY_LOCAL.telephone}
          </a>
        </div>
        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-gray-300">Pages</p>
          <ul className="mt-3 space-y-2 text-sm text-gray-400">
            <li><Link to="/" className="hover:text-white">Homepage</Link></li>
            <li><Link to="/menu" className="hover:text-white">Menu</Link></li>
            <li><Link to="/order" className="hover:text-white">Order</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy</Link></li>
          </ul>
        </div>
      </div>
      <p className="border-t border-white/10 py-6 text-center text-xs text-gray-500">
        © {year} Nanny B&apos;s Bakery. Photo list — not indexed.
      </p>
    </footer>
  );
}
